import React from 'react';
import { useStyles } from "./Footer.css";
import { useSelector } from "react-redux";
import { AppBar, Toolbar, Grid, Typography, IconButton } from '@material-ui/core';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import { useLocation } from "react-router-dom";
import Tooltip from '@material-ui/core/Tooltip';

export default function Footer({ frontendColor, ssoActive, releaseNum }) {
    const classes = useStyles();
    const userSession = useSelector(state => state.session);
    const location = useLocation();

    const handleConnexionAdmin = () => {
        window.location = "/backend/connexion"
    }

    return (
        !location.pathname.toLowerCase().includes("/frontend/planningalone/") && <AppBar position="fixed" color="primary" className={classes.appBar} style={{ background: location.pathname.includes("/frontend/") && frontendColor}}>
                <Toolbar className={classes.toolBarClass}>
                    <Grid container alignItems="flex-start" spacing={2}>
                        <Grid item xs={6} style={{textAlign:"left"}}>
                            <Typography className={classes.alignTextLeft} variant="caption" >2022 © Lysoft SA - v{releaseNum}</Typography>
                        </Grid>
                        <Grid item xs={6} style={{ textAlign: "right" }}>
                            <Typography className={classes.alignTextRight} variant="caption" >{userSession.appVersion}</Typography>
                        {(!userSession.connected && !location.pathname.includes("/mediaserver/")) &&
                            <Tooltip
                                title={<h3>Connexion Administrateur</h3>}
                                aria-label='Connexion Administrateur'
                            >
                                <IconButton style={{ padding: "0px" }} edge="start" className={classes.menuButton} onClick={handleConnexionAdmin} color="inherit" aria-label="logout">
                                    <SupervisorAccountIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
    )
}